module.exports = __webpack_public_path__ + "static/img/surface1.e088005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface1.png
// module id = Jfyo
// module chunks = 2